import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 40000;
const SLUG = "prize-bond-40000-result-today";
const TITLE =
  "Prize Bond 40000 Result Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 40,000 Premium Prize Bond result today — highest denomination Pakistan. Filer-only registered bond checker with National Savings official data.";

const HOW_TO_STEPS = [
  { title: "Rs. 40,000 premium chunein", body: "Denomination bar mein red Rs. 40,000 ⭐ chip par tap karein — yeh Pakistan ka sab se bara premium prize bond hai." },
  { title: "Registered number likhein", body: "Rs. 40,000 premium bond ka serial number 8 digits tak hota hai — original bond ke face par printed hota hai." },
  { title: "Bulk mein kayi paste karein", body: "Agar aap high-net-worth investor hain aur multiple bonds hain to Bulk tab mein sab paste kar dein (max 100)." },
  { title: "Check aur draw details", body: "Result cards mein draw number, city aur exact prize amount show hoti hai — SBP record se cross-verify bhi ho sakti hai." },
  { title: "Registered account mein credit", body: "Prize amount direct aap ke SBP-registered bank account mein 15-30 din mein transfer ho jati hai — bearer cash withdrawal nahi hota." },
];

const FAQS = [
  { q: "Rs. 40,000 prize bond ka result today kaise dekhein?", a: "Upar checker mein premium 40,000 chip select karein aur 8-digit registered bond number input mein daalein. Hamara data National Savings ki Rs. 40,000 draw PDF se sync hota hai — draw complete hone ke 24 hours ke andar aap ke result available hote hain." },
  { q: "40000 premium bond ka first prize kitna hai?", a: "First prize Rs. 8,00,00,000 (8 crore) — 1 winner. Second prize Rs. 3,00,00,000 (3 crore) — 3 winners. Third prize Rs. 5,00,000 — 1,696 winners. Yeh Pakistan ka highest jackpot prize bond hai." },
  { q: "Kya Rs. 40,000 sirf filer ke liye hai?", a: "Ji haan — 2019 ke baad Rs. 40,000 premium bond sirf tax filers hi kharid sakte hain. Application ke waqt FBR active taxpayer status aur CNIC verification mandatory hai. Non-filer application reject ho jati hai." },
  { q: "40000 wala prize bond ki 6-monthly profit kya hai?", a: "Prize ke ilawa premium bonds par regular profit bhi milta hai — approx 5-7% annualized, jo 6-mahine ke intervals mein direct bank account mein credit hota hai. Yeh feature bearer bonds mein nahi hoti." },
  { q: "Rs. 40,000 draw kab kab hoti hai?", a: "Rs. 40,000 premium draw quarterly hoti hai — usually March, June, September, December ke pehle hafte mein. Alag rotation ke sath Rs. 25,000 draw ke ek mahine baad. Exact date National Savings publish karta hai." },
  { q: "40000 bond gum ho jaye to kya karna hai?", a: "Chunki registered hai, SBP ke pas complete record hota hai. Aap ko FIR aur newspaper advertisement ke bina bhi duplicate issue ho sakta hai — sirf SBP branch mein CNIC copy, purani receipts aur affidavit jama karayein. Process 30-45 din mein complete hoti hai." },
  { q: "Non-filer purana Rs. 40,000 bond bhi rakh sakta hai?", a: "Purane holdings (2019 se pehle wale) grandfathered hain — koi force selling nahi thi. Lekin new purchases sirf filer kar sakta hai. Non-filer par prize par 30% withholding tax kata jayega." },
  { q: "Kya Rs. 40,000 bond investment ke liye acha hai?", a: "High-net-worth investors ke liye acha hai jo tax filer hain aur long-term capital preservation chahte hain — 100% SBP guarantee, 6-monthly profit ~6%, aur jackpot upside. Chotay investors ke liye Rs. 750 ya Rs. 1,500 zyada practical hain." },
  { q: "Rs. 40,000 par 8 crore jeetne ke chances?", a: "Har draw mein sirf 1 first prize. Agar total 40,000 bonds circulation mein N hain to chance 1/N — typically 1 in 15-20 lakh. Chotay prizes (Rs. 5 lakh × 1696) zyada realistic — statistically 100 bonds rakhne wale ko 3-5 saal mein ek chota inaam mil sakta hai." },
  { q: "40000 bond kahan se kharidein?", a: "Sirf SBP Banking Services Corporation ki designated branches aur select commercial bank branches se — application form, filer status certificate, CNIC copy, bank account details aur nominee information ke sath. Process 7-10 din leti hai." },
];

const RELATED = [
  { href: "/prize-bond-25000-result-today", label: "Rs. 25,000 Premium" },
  { href: "/prize-bond-list-750-today", label: "Rs. 750 Prize Bond" },
  { href: "/prize-bond-1500-result-today", label: "Rs. 1,500 Prize Bond" },
  { href: "/prize-bond-100-result-today", label: "Rs. 100 Prize Bond" },
  { href: "/prize-bond-200-result-today", label: "Rs. 200 Prize Bond" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-40000-result-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 40,000 Premium Prize Bond result today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="Prize Bond 40000 Result Today — Highest Premium Bond Checker"
      h1Hinglish="40,000 Wala Prize Bond Ka Aaj Ka Result — Filer-Only Bond"
      introParagraphs={[
        "Rs. 40,000 Pakistan ka highest denomination premium prize bond hai — Rs. 8 crore jackpot ke sath. Yeh sirf tax filers ke liye reserved hai aur registered form mein aata hai, matlab har bond kisi specific CNIC-holder ke naam pehle se linked hota hai. Is page par aap seedha aaj ka draw result seconds mein confirm kar sakte hain.",
        "Data National Savings Pakistan ki official Rs. 40,000 draw PDF se sync hota hai. Draw complete hote hi hamara backend winners parse karke checker mein feed kar deta hai — koi PDF download, koi WhatsApp forward, koi wait nahi.",
        "Neeche checker ke baad Rs. 40,000 ki filer-only policy, 6-monthly profit, tax treatment aur high-net-worth investor perspective par detailed content diya gaya hai — sirf isi denomination ke liye tailor kiya hua.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 8,00,00,000" },
        { label: "2nd Prize (×3)", value: "Rs. 3,00,00,000" },
        { label: "3rd Prize (×1696)", value: "Rs. 5,00,000" },
        { label: "Eligibility", value: "Filer Only · Premium" },
      ]}
      sections={[
        {
          id: "filer-only-policy",
          heading: "Filer-Only Policy — Kyun Sirf Tax Filers",
          body: (
            <>
              <p>
                2019 mein FBR aur SBP ne joint circular jari kiya jis mein Rs. 40,000 premium bond ki new purchases sirf
                active tax filers tak restrict kar di gayin. Wajah simple thi — high-value bonds anti-money-laundering
                FATF requirements ke ambit mein aate hain, aur filer status yeh confirm karta hai ke funds documented
                aur declared hain. Purane holdings grandfathered ki gayin taake sudden liquidity crisis na ho.
              </p>
              <p>
                Aaj bhi non-filer secondary market mein Rs. 40,000 bond khareed sakta hai (private party se), lekin
                claim ke waqt prize par 30% withholding tax deduct hoga — jo filer ke 15% se double hai.
              </p>
            </>
          ),
        },
        {
          id: "hnw-strategy",
          heading: "High-Net-Worth Investors Ke Liye Rs. 40,000",
          body: (
            <>
              <p>
                Wealthy families aksar Rs. 40,000 bonds ki bulk holdings rakhte hain — 50 se 500 bonds tak. Wajah teen
                hain: (1) 100% SBP guarantee ke saath principal safe hai, (2) 6-monthly profit ~6% annualized regular
                income deti hai, aur (3) Rs. 8 crore jackpot ka upside speculation hai. Yeh strategy Islamic banking
                Sukuk aur savings certificates ki complement mein use hoti hai — diversified fixed-income portfolio.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
